import React from 'react';
import { useParams, Outlet, useNavigate, useLocation } from 'react-router-dom';
import {NestedTabs} from './NestedTabs';
import { useNavigateTo } from '../../components-system/routing/use-navigate-to.hook';
import { NavigateToNotFound } from '../_shared/navigation/NavigateTo';
import { Page, RenderChildren } from '../layout';

export type TabbedPageProps1 = any & {
  children: any[]
}

export const TabbedPage = (props:TabbedPageProps1) => {
  const { assignmentId } = useParams();
  const {navigateToNotFound} = useNavigateTo();
  // const currentPage =  config.pages.find((page:any) => page.path === `/courses/${courseId}`);

  // if (!currentPage) {
  //   navigateToNotFound(); // Redirect to a 404 page if pageId is not found
  //   return null;
  // }

  return (
    <Page title={props.title}>

      <NestedTabs tabs={(props as any).tabs as any} parentPath={`/assignments/${assignmentId}`} />
      <RenderChildren children={props.children} />
    </Page>
  );
};

